export default __webpack_public_path__ + "static/media/map-marker.deab3ed9.svg";